const apiUrls = require('../../constants/apiUrls');
const callAhead = {
    key: 'callAhead',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_CALL_AHEAD_URL}?workOrderNumber=${request.orderId}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default callAhead;


// WEBPACK FOOTER //
// ./src/store/order-details-config/callAhead.js